import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';

const VERTICAL_DRAWER_LINK_MAX_LABEL_LENGTH = 15;
// const MAX_VERTICAL_LINKS_PER_ROUTE = 5;

const getText = (obj, prop, params) => {
  let label = obj[prop];
  if (label && (typeof (label) === 'function')) {
    label = label(params);
  }
  return label;
};

const getBoolean = (obj, prop, params) => {
  let value = obj[prop];
  if (value && (typeof (value) === 'function')) {
    value = value(params);
  }
  return value;
};

const ACTIVE_MATCHER = () => true;
const INACTIVE_MATCHER = () => false;
class VerticalDrawerLink extends React.Component {
  static getRouteState = (props) => {
    const { route, location } = props;
    let label = getText(route, 'drawerLabel', props) || getText(route, 'label', props);
    if (label && label.length && (label.length > VERTICAL_DRAWER_LINK_MAX_LABEL_LENGTH)) {
      label = `...${label.substring(label.length - VERTICAL_DRAWER_LINK_MAX_LABEL_LENGTH + 3)}`;
    }
    const disabled = getBoolean(route, 'disabled', props);
    return {
      label,
      disabled,
      Icon: route.icon,
      to: disabled ? '' : route.url(props),
      active: route.matchLocation(null, location) ? ACTIVE_MATCHER : INACTIVE_MATCHER,
      id: route.id,
    };
  };

  static propTypes = {
    route: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = VerticalDrawerLink.getRouteState(props);
  }

  static getDerivedStateFromProps(props, state = {}) {
    const newState = VerticalDrawerLink.getRouteState(props);
    const changed = newState.label !== state.label
            || newState.disabled !== state.disabled
            || newState.Icon !== state.Icon
            || newState.to !== state.to
            || newState.active !== state.active;
    return changed ? newState : null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const changed = nextState.label !== this.state.label
        || nextState.disabled !== this.state.disabled
        || nextState.Icon !== this.state.Icon
        || nextState.to !== this.state.to
        || nextState.active !== this.state.active;
    return changed;
  }

  render() {
    const { label, to, Icon, disabled, active, id } = this.state;
    return (
      <NavLink
        to={to}
        className={classNames('tuc-vertical-drawer-link', disabled && 'disabled')}
        activeClassName="active-link"
        isActive={active}
        disabled={disabled}
        id={`primaryLink${id}`}
      >
        {Icon && <Icon />}
        {label && <Typography variant="caption">{label}</Typography>}
      </NavLink>
    );
  }
}

export default VerticalDrawerLink;
